import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext, startTransition } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../services/EventService";
import { AppDB } from "../App";
import ScreenLoader from "../componets/ScreenLoader";
import e from "cors";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputNumber } from "primereact/inputnumber";
import { Divider } from "primereact/divider";
import { FileUpload } from "primereact/fileupload";
import AddSignature from "./AddSignature";
import GenericFileCapture from "./GenericFileCapture";
import GenericUploadFileTable from "./GenericUploadFileTable";
import { lookupsService } from "../services/LookupsService";
import $ from 'jquery'



export default function AddEvent({
	eventGroupId = null,
	showAddEvent,
	setShowAddEvent,
	setData = [],
	buttonIcon = "pi pi-save",
	show = false,
	setShow,
	eventTypes,
	selectedEvent,
	IsByElection,
	setEvents,
	IsOneDemarcationEvent = false,
}) {
	var [form, setForm] = useState({
		name: "",
		description: ""
	});
	var [formError, setFormError] = useState({
		name: "",
		description: "",
		eventCategory: "",
		eventType: ""
	});
	var [selectedType, setSelected] = useState(null);
	var [selectedCategory, setSelectedCategory] = useState(null);
	const [parametersList, setParametersList] = useState({});
	var [parametersListErr, setParametersListErr] = useState([]);
	const [parametersListUI, setParametersListUI] = useState([]);
	const [parameterGroups, setParameterGroups] = useState([]);
	const [showParameters, setshowParameters] = useState(false);
	const [error, setError] = useState("");
	const [isLoading, setisLoading] = useState(false);
	const { setallEventsPerGroup, groupEventInfo, toast } = useContext(AppDB);
	var [submitAttempted, setSubmitAttempted] = useState(false);

	useEffect(() => {
		if (IsByElection) {
			setshowParameters(true);
			setSelected(selectedEvent.eventTypeID);
			GetEventCategoryParametersById(selectedEvent.eventCategoryID);
		}
	}, []);

	function eventHandler(e) {
		setshowParameters(true);
		setSelected(e.value);
		var id = e.value?.eventGroupID ? e.value.eventGroupID : null;
	}

	function GetEventCategoryParametersById(id) {
		setisLoading(true);
		eventService
			.GetCategoryParametersByAsync({
				EventCategoryID: id, ApplicabilityID: 1,
				IsOneDemarcationEvent: IsOneDemarcationEvent
			}) //1 means event parameters)
			.then((data) => {
				setParameterGroups(data);
				setisLoading(false);
			})
			.catch((err) => {
				console.log(err);
			});
	}
	function categoryHandler(e) {
		setisLoading(true);

		setParametersList([]);
		setSelectedCategory(e.value);
		var id = e.value?.eventCategoryID ? e.value.eventCategoryID : null;
		setisLoading(true);
		eventService
			.GetCategoryEventTypesByID(id)
			.then((data) => {
				setEventTypes(data);
				GetEventCategoryParametersById(id);
				setisLoading(false);
				setSelected(null);
			})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
			});
	}
	var [eventTypes, setEventTypes] = useState([]);
	var [eventCategories, setEventCategories] = useState([]);
	useEffect(() => {
		setEventTypes(eventTypes);
		GetEventCategories();
		GetDocumentTypes();
	}, []);

	useEffect(() => {
		if (parametersListUI[1]) {
			isValid();
		}
	}, []);

	const [showuploadDocs, setshowuploadDocs] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);

	var [refresh, setRefresh] = useState(true);
	async function GetEventCategories() {
		setisLoading(true);
		await eventService
			.GetEventCategories()
			.then((data) => {
				setEventCategories(data);
				setisLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
			});
	}

	const [documentType, setdocumentType] = useState([]);
	async function GetDocumentTypes() {
		lookupsService.getDocumentTypes({
			DocumentCategoryID: 4
		}).then((res) => {
			setisLoading(false);
			setdocumentType(res)
		}).catch((err) => {
			console.log(err);
			setisLoading(false);
		});

	}
	function FormValitation() {
		var valid = true;

		Object.keys(form).forEach((key) => {
			if (!form[key]) {
				setFormError((preForm) => ({ ...preForm, [key]: "Required." }));
				valid = false;
			} else {
				setFormError((preForm) => ({ ...preForm, [key]: "" }));
			}
		});
		return valid;
	}
	function FormatDateToISO(date) {
		if (date) {
			return `${date.getFullYear().toString().padStart(4, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}T00:00:00.000Z`;
		}
		return null;
	}
	const [trackParameterChanges, setTrackParameterChanges] = useState({});

	const SubmitForm = () => {
		// Run validation for all form parameters
		if (!validateAllFormParameters()) {
			setSubmitAttempted(true);
			toast.show({
				severity: "error",
				summary: "Validation Error",
				detail: "Please correct the errors before submitting.",
				life: 3000
			});
			return; // Stop submission if validation fails
		}

		setSubmitAttempted(true);
		setisLoading(true);

		// Stop submission if there are errors
		if (error) {
			toast.show({
				severity: "error",
				summary: "Validation Error",
				detail: error,
				life: 3000
			});
			setisLoading(false);
			return;
		}

		var parameters = [];
		Object.keys(parametersList).forEach((key) => {
			parameters.push({
				parameterID: parametersList[key].parameterID,
				value: parametersList[key].value?.toString(),
				startdate: FormatDateToISO(parametersList[key].startdate),
				enddate: FormatDateToISO(parametersList[key].enddate)
			});
		});

		let eventDocuments = JSON.parse(JSON.stringify(fileUploaderDocuments));
		eventDocuments = eventDocuments.map(doc => {
			var _do = doc.binaryData.split(",");
			if (_do.length >= 2) {
				doc.binaryData = _do[1];
			}
			return doc;
		})
		const payload = {
			documents: eventDocuments,
			EventGroupID: eventGroupId,
			EventTypeID: IsByElection ? 3 : selectedType,
			Name: form?.name,
			Description: form?.description,
			ParentEventID: IsByElection ? selectedEvent.eventID : null,
			EventCategoryID: IsByElection ? selectedEvent.eventCategoryID : selectedCategory?.eventCategoryID,
			EventParameters: parameters,
			EventDelimitationID: IsByElection ? selectedEvent.eventDelimitationId : null
		};

		// Additional form validation
		if (!FormValitation()) {
			setisLoading(false);
			return;
		}
		eventService
			.create(payload)
			.then((res) => {
				if (res?.success) {
					setShowAddEvent(false);
					if (!IsByElection) {
						setEvents();
					}
				} else {
					const serverErrors = {};
					res.data?.forEach((element) => {
						serverErrors[element.parameterID] = element.message;
					});
					setParametersListErr(serverErrors);
				}

				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 3000
				});
			})
			.catch((err) => {
				console.error("Error:", err);
				toast.show({
					severity: "error",
					summary: "Error Message",
					detail: err.message,
					life: 3000
				});
			})
			.finally(() => {
				setisLoading(false);
			});
	};

	function formatDateToDDMMYYYY(date) {
		return date ? `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}` : "";
	}

	const validateAllFormParameters = () => {
		let hasErrors = false;

		setisLoading(false); // Stop loading before validation

		const newErrors = {}; // Temporary object to collect all errors

		// Validate eventCategory
		if (form.eventCategory === null) {
			newErrors.eventCategory = "Required";
			hasErrors = true;
		}

		// Validate eventType
		if (form.eventType === null) {
			newErrors.eventType = "Required";
			hasErrors = true;
		}

		// Validate mandatory date parameters
		parameterGroups.forEach((group) => {
			group.parameters
				.filter((param) => param.mandotory) // Fix typo: "mandatory"
				.forEach((element) => {
					const parameter = parametersList[element.parameterID];

					if (!parameter || !(parameter.startdate || parameter.enddate || parameter?.value)) {
						newErrors[element.parameterID] = "Required.";
						hasErrors = true;
					}
				});
		});

		setParametersListErr((prevErrors) => ({ ...prevErrors, ...newErrors }));

		return !hasErrors;
	};

	function isValid() {
		let electionStartDate = null;
		let electionEndDate = null;
		let electionDate = null;
		let nominationDate = null;

		let hasErrors = false;

		// Find election period start and end dates
		parameterGroups.forEach((group) => {
			group.parameters.forEach((param) => {
				var parameter = parametersList[param.parameterID];

				if (parameter?.parameterID === 1) { // Election period
					electionStartDate = new Date(parameter.startdate);
					electionEndDate = new Date(parameter.enddate);
				}

				if (parameter?.parameterID === 2) { // Election day
					electionDate = new Date(parameter.startdate);
				}

				if (parameter?.parameterID === 7) { // Nomination day
					nominationDate = new Date(parameter.startdate);
				}
			});
		});

		const formattedElectionPeriod = `${formatDateToDDMMYYYY(electionStartDate)} - ${formatDateToDDMMYYYY(electionEndDate)}`;

		// Loop through parameters and validate their date ranges
		parameterGroups.forEach((group) => {
			group.parameters
				.filter((param) => param.mandotory)
				.forEach((element) => {
					var parameter = parametersList[element.parameterID];

					if (parameter?.startdate && parameter?.enddate) {
						const paramStartDate = new Date(parameter.startdate);
						const paramEndDate = new Date(parameter.enddate || parameter.startdate);

						// Validate if dates are within election period
						if (!isNaN(paramStartDate) && !isNaN(paramEndDate) && selectedType != 4) {
							if (paramStartDate >= electionStartDate && paramEndDate <= electionEndDate) {
								setParametersListErr((prev) => ({
									...prev,
									[element.parameterID]: ""
								}));
							} else {
								setParametersListErr((prev) => ({
									...prev,
									[element.parameterID]: `Date must be within Election period ${formattedElectionPeriod}.`
								}));
								hasErrors = true;
							}
						}
					}
				});
		});

		// Validate nomination day vs election day (should be between 30-60 days before election)
		if (electionDate && nominationDate) {
			const dayDifference = Math.floor((electionDate - nominationDate) / (1000 * 60 * 60 * 24)); // Convert ms to days

			if (dayDifference >= 30 && dayDifference <= 60) {
				setParametersListErr((prev) => ({
					...prev,
					7: ""
				}));
			} else if (dayDifference > 60) {
				setParametersListErr((prev) => ({
					...prev,
					7: "Nominations day cannot be more than 60 days before the election."
				}));
				hasErrors = true;
			} else if (dayDifference < 30) {
				setParametersListErr((prev) => ({
					...prev,
					7: "Nominations day cannot be less than 30 days before the election."
				}));
				hasErrors = true;
			}
		}
	}

	const handleInputChange = (value, parameterID, parameterType) => {
		let startdate = null;
		let enddate = null;
		let parameterValue = "";

		if (parameterType == 1 || parameterType == 2) {
			parameterValue = value;
		} else if (parameterType == 4) {
			if (Array.isArray(value) && value.length > 0) {
				startdate = value[0];
				enddate = value.length === 1 ? startdate : value[1] || startdate;
			}
			setParametersListUI((prevForm) => ({ ...prevForm, [parameterID]: value }));
			if (value.length === 2 && value[0] && value[1]) {
				setTimeout(() => {
					const $input = $('.p-calendar input:focus');
					if ($input.length === 2) {
						$input.blur();
					}
					else {
						$input.blur();
					}
					$('body').trigger('click');

				}, 0);
			}

		}
		else if (parameterID === 1) {
			setParametersListUI((prevForm) => ({ ...prevForm, [parameterID]: value }));
		}

		var updatedValue = { parameterID, value: parameterValue, startdate, enddate };

		setParametersList((prev) => {
			const newState = {
				...prev,
				[parameterID]: {
					...(prev[parameterID] || {}),
					...updatedValue
				}
			};

			return newState;
		});
		isValid();
	};

	return (
		<Dialog
			draggable={false}
			header={
				<>
					<li className="pi pi-plus"> </li>
					<span>{IsByElection ? " Add By - Election Event" : " Add Event"}</span>
				</>
			}
			footer={
				<>
					<Button className="p-button-danger" type="button" label="Close" onClick={() => setShowAddEvent(false)} />
					<Button label="Submit" onClick={SubmitForm} className="p-button-success" icon="pi pi-plus" type="submit" loading={isLoading} />
				</>
			}
			visible={showAddEvent}
			onHide={(e) => setShowAddEvent(false)}
			style={{ width: "98%", height: "98%" }}
		>
			{isLoading && (
				<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
					<ScreenLoader visible={isLoading} />
				</div>
			)}
			{/* <BreadCrumb model={items} className="my-2"/> */}
			<div className="grid">
				<div className="col-12 lg:col-12">
					<form>
						<section className="p-4 border rounded  mt-4 sm:mt-2 w-full">
							<h2 className="lg:text-[18px] md:text-[16px] text-[14px] font-semibold"></h2>

							<Divider align="center">
								<h3>Event Details</h3>
							</Divider>

							<div className="card ">
								<div className="grid">
									<div className="col-12  lg:col-6">
										<label style={{ marginBottom: "5px" }}>Event Name <span className="text-error">*</span></label>
										<TextInput
											value={form.name}
											onChange={(e) => setForm({ ...form, name: e.target.value })}
										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{formError?.name}</label>
									</div>

									<div className="col-12  lg:col-6">
										<label style={{ marginBottom: "5px" }}>Description <span className="text-error">*</span></label>
										<TextInput
											value={form.description}
											onChange={(e) => setForm({ ...form, description: e.target.value })}

										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{formError?.description}</label>
									</div>
									{!IsByElection && (
										<>
											<div className="col-12  lg:col-6">
												<label className="lg:text-[16px] md:text-[12px] text-[11px] py-1 my-1">Event Category <span className="text-error">*</span></label>
												<Dropdown
													optionLabel="name"
													onChange={(e) => categoryHandler(e)}
													options={eventCategories}
													value={selectedCategory}
													placeholder="Event Category"
													style={{ width: "100%" }}
												/>
												<label style={{ color: "red", marginBottom: "5px" }}>{formError?.eventCategory}</label>
											</div>
											{selectedCategory !== null ? (
												<div className="col-12  lg:col-6">
													<label className="lg:text-[16px] md:text-[12px] text-[11px] py-1 my-1">Event Type <span className="text-error">*</span></label>
													<Dropdown
														optionLabel="text"
														onChange={(e) => eventHandler(e)}
														options={eventTypes}
														value={selectedType}
														placeholder="Event Type"
														style={{ width: "100%" }}
													/>
													<label style={{ color: "red", marginBottom: "5px" }}>{formError?.eventType}</label>
												</div>
											) : (
												""
											)}
										</>
									)}
								</div>
								{showParameters && (
									<>
										<br />
										<br />
										<Divider align="center">
											<h3>Event Parameters</h3>
										</Divider>
										<div className="">
											{parameterGroups
												.filter((group) => group.parameters.some((param) => param.mandotory))
												.map((group) => (
													<div className="card">
														<div className="flex flex-wrap gap-4">
															{group.parameterGroupID == 1 ? (
																<></>
															) : (
																<>
																	<h5>{group.name}</h5>
																	<hr />
																</>
															)}
														</div>

														<div className="card flex flex-wrap">
															{group.parameters
																.filter((param) => param.mandotory)
																.map((param) => (
																	<>
																		{param.parameterTypeID == 1 && ( //number
																			<div style={{ width: "50%" }} className="my-2 ">
																				{" "}
																				<label>
																					{param.name}{" "}
																					{param.mandotory && <span className="text-error">*</span>}
																				</label>
																				<InputNumber
																					tooltip={param.description}
																					style={{ width: "99%" }}
																					value={parametersList[param.parameterID]?.value || null}
																					onValueChange={(e) =>
																						handleInputChange(
																							e.target.value,
																							param.parameterID,
																							param.parameterTypeID
																						)
																					}
																					useGrouping={false}
																				/>
																				<label style={{ color: "red", marginBottom: "5px" }}>
																					{parametersListErr[param.parameterID]}
																				</label>
																			</div>
																		)}
																		{param.parameterTypeID == 2 && ( //String
																			<div style={{ width: "50%" }} className="my-2 ">
																				{" "}
																				<label>
																					{param.name}{" "}
																					{param.mandotory && <span className="text-error">*</span>}
																				</label>
																				<TextInput
																					tooltip={param.description}
																					style={{ width: "99%" }}
																					value={parametersList[param.parameterID]?.value || ""}
																					onChange={(e) =>
																						handleInputChange(
																							e.target.value,
																							param.parameterID,
																							param.parameterTypeID
																						)
																					}
																				/>
																				<label style={{ color: "red", marginBottom: "5px" }}>
																					{parametersListErr[param.parameterID]}
																				</label>
																			</div>
																		)}
																		{param.parameterTypeID == 4 && ( //Date
																			<div style={{ width: "50%" }} className="my-2 ">
																				{" "}
																				<label>
																					{param.name}{" "}
																					{param.mandotory && <span className="text-error">*</span>}
																				</label>
																				<Calendar

																					tooltip={param.description}
																					dateFormat="dd/mm/yy"
																					placeholder="dd/mm/yyyy - dd/mm/yyyy"
																					style={{ width: "99%" }}
																					value={parametersListUI[param.parameterID]}
																					onChange={(e) =>
																						handleInputChange(
																							e.target.value,
																							param.parameterID,
																							param.parameterTypeID
																						)
																					}
																					showTime={false}
																					showIcon={true}
																					selectionMode="range"
																					hideOnRangeSelection
																				/>
																				<label style={{ color: "red", marginBottom: "5px" }}>
																					{parametersListErr[param.parameterID]}
																				</label>
																			</div>
																		)}
																	</>
																))}
														</div>
														<br />
														<br />
													</div>
												))}
										</div>
										{parameterGroups
											.filter((group) => group.parameters.some((param) => !param.mandotory))
											.map((group) => (
												<section>
													<div className="flex flex-wrap gap-1">
														{group.parameterGroupID == 1 ? (
															<></>
														) : (
															<>
																<h5>{group.name}</h5>
																<hr />
															</>
														)}
													</div>
													<div className="card flex flex-wrap">
														{group.parameters
															.filter((param) => !param.mandotory)
															.map((param) => (
																<>
																	{param.parameterTypeID == 1 && ( //number
																		<div style={{ width: "50%" }} className="my-1 ">
																			{" "}
																			<label>
																				{param.name}{" "}
																				{param.mandotory && <span className="text-error">*</span>}
																			</label>
																			<InputNumber
																				tooltip={param.description}
																				style={{ width: "99%" }}
																				value={parametersList[param.parameterID]?.value || null}
																				onValueChange={(e) =>
																					handleInputChange(
																						e.target.value,
																						param.parameterID,
																						param.parameterTypeID
																					)
																				}
																				useGrouping={false}
																			/>
																			<label style={{ color: "red", marginBottom: "5px" }}>
																				{parametersListErr[param.parameterID]}
																			</label>
																		</div>
																	)}
																	{param.parameterTypeID == 2 && ( //String
																		<div style={{ width: "50%" }} className="my-1 ">
																			{" "}
																			<label>
																				{param.name}{" "}
																				{param.mandotory && <span className="text-error">*</span>}
																			</label>
																			<TextInput
																				tooltip={param.description}
																				style={{ width: "99%" }}
																				value={parametersList[param.parameterID]?.value || ""}
																				onChange={(e) =>
																					handleInputChange(
																						e.target.value,
																						param.parameterID,
																						param.parameterTypeID
																					)
																				}
																			/>
																			<label style={{ color: "red", marginBottom: "5px" }}>
																				{parametersListErr[param.parameterID]}
																			</label>
																		</div>
																	)}
																	{param.parameterTypeID == 4 && ( //Date
																		<div style={{ width: "50%" }} className="my-1 ">
																			{" "}
																			<label>
																				{param.name}{" "}
																				{param.mandotory && <span className="text-error">*</span>}
																			</label>
																			<Calendar
																				tooltip={param.description}
																				dateFormat="dd/mm/yy"
																				placeholder="dd/mm/yy"
																				style={{ width: "99%" }}
																				value={parametersListUI[param.parameterID]}
																				onChange={(e) => {
																					handleInputChange(
																						e.value,
																						param.parameterID,
																						param.parameterTypeID
																					)
																					Object.keys(trackParameterChanges).forEach((key) => {
																						parametersListErr = parametersListErr.filter((err) => {
																							if (key in err) {
																								return true
																							}
																							return false
																						})
																					})
																					setParametersListErr([...parametersListErr])

																				}
																				}
																				showTime={false}
																				showIcon={true}
																				selectionMode="range"
																				hideOnRangeSelection
																			/>
																			<label style={{ color: "red", marginBottom: "5px" }}>
																				{parametersListErr[param.parameterID]}
																			</label>
																		</div>
																	)}
																</>
															))}
													</div>
													<br />
													<br />
												</section>
											))}
									</>
								)}
							</div>

							<Divider align="center">
								<h3>Documents </h3>
							</Divider>
							<div className="card ">
								<div className="grid">
									{/* <div className="col-12  lg:col-4">
										<label className="lg:text-[16px] md:text-[12px] text-[11px] py-1 my-1">Document Type</label>
										<Dropdown
											optionLabel="name"
											value={selectedDocument}
											options={documentType}
											onChange={(e) => setselectedDocument(e.value)}
											placeholder="Select Document"
											style={{ width: "100%" }}
										/>
									</div> */}
									<div className="col-12">
										<GenericFileCapture
											dontClearDocuments={true}
											refresh={refresh}
											setRefresh={setRefresh}
											requestCall={() => { }}
											extraAttributes={{}}
											documentTypesLookUp={documentType}
											show={showuploadDocs}
											setShow={setshowuploadDocs}
											setDocuments={setFileUploaderDocuments}
											documents={fileUploaderDocuments}
										/>
										<GenericUploadFileTable
											header={
												<div className="col-12 my-2">
													<label htmlFor="description" className="required-input-asterisk">Upload Documents</label>
													<br />
													<>
														<Button
															label={"Upload"}
															onClick={() => setshowuploadDocs(true)}
															className="p-button-success"
															icon={"pi pi-plus"}
														/>
													</>
												</div>
											}
											setDocuments={setFileUploaderDocuments}
											documents={fileUploaderDocuments} />
									</div>
								</div>
							</div>
						</section>
					</form>
				</div>
			</div>
		</Dialog>
	);
}
